/* vim: set expandtab sw=2 ts=2 sts=2: */
import React from 'react';
import FilterLink from './FilterLink';
import types from '../../actions/actionTypes';

const Footer = () => (
  <div>
    Show: 
    {" "}
    <FilterLink filter={types.SHOW_ALL}>All</FilterLink>
    {", "}
    <FilterLink filter={types.SHOW_ACTIVE}>Active</FilterLink>
    {", "}
    <FilterLink filter={types.SHOW_COMPLETED}>Completed</FilterLink>
  </div>
)

export default Footer;



// WEBPACK FOOTER //
// ./usr/lib/ui/src/containers/todos/Footer.js